/*
 * VM for creating a franchised
 */
export default class FranchisedVM {
    constructor(
      public companyName?: string,
      public gender?: string,
      public firstName?: string,
      public lastName?: string,
      public email?: string,
      public franchisorId?:number,
      public nbConseiller?:number,
      public nbClient?:number,
    ) {}
  }
  